import { createSelector } from 'reselect';
import { retailTracEnabled } from 'services/FeatureFlags';

export const getRouter = (state) => state.router;

export const isDashboardOrAccounts = createSelector(getRouter, (router) => {
  const { pathname } = router.location;

  let page =
    (pathname && pathname !== '/' && pathname.substring(1, pathname.length)) ||
    '/';
  return (
    page === '/' ||
    page === 'dashboard' ||
    page === 'accounts' ||
    page === 'login'
  );
});

export const isDashboardOnly = createSelector(getRouter, (router) => {
  const { pathname } = router.location;

  let page =
    (pathname && pathname !== '/' && pathname.substring(1, pathname.length)) ||
    '/';

  return (
    page === '/' ||
    page === 'dashboard'
  );
});

export const isSummitPage = createSelector(getRouter, (router) => {
  if(!retailTracEnabled()) {
    return false;
  }

  const { pathname } = router.location;

  let page =
    (pathname && pathname !== '/' && pathname.substring(1, pathname.length)) ||
    '/';
  return (
    page === 'program-benefits'
  );
});

export const isWorkplaceNavigation = createSelector(getRouter, (router) => {
  if(!retailTracEnabled()) {
    return false;
  }

  const { pathname } = router.location;

  let page =
    (pathname && pathname !== '/' && pathname.substring(1, pathname.length)) ||
    '/';
  return (
    page === 'workplace'||
    page === 'workplace-small-business'
  );
});
